import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import type { BlogEntity, PickedBlogEntity } from '@/interfaces'

export const facilities = ['Fort Lauderdale', 'Fort Pierce', 'Riviera Beach', 'Jacksonville']

export type EssentialStoreType = {
	ga4ID: string
	logo: string
	name: string
	facilities: Array<string>
	blogs: Array<PickedBlogEntity>
	setBlogs: (blogs: Array<PickedBlogEntity>) => void
	suggestions: Array<PickedBlogEntity>
	setSuggestions: (blogs: Array<PickedBlogEntity>) => void
	total: number
	setTotal: (total: number) => void
	blog: BlogEntity | null
	setBlog: (blog: BlogEntity | null) => void
}
export const useEssentialStore = create<EssentialStoreType>()(
	devtools<EssentialStoreType>(
		(set) => ({
			facilities,
			ga4ID: 'G-TMW3X1DRB1',
			logo: '/images/logo.webp',
			name: 'WellView Care',
			blogs: [],
			setBlogs: (blogs) => set({ blogs }),
			suggestions: [],
			setSuggestions: (suggestions) => set({ suggestions }),
			total: 0,
			setTotal: (total) => set({ total }),
			blog: null,
			setBlog: (blog) => set({ blog }),
		}),
		{
			name: 'WVCEssentialStore',
			store: 'WVCEssentialStore',
		},
	),
)
